module.exports = __webpack_public_path__ + "img/home_card_3.eeb3db5e.webp";